<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    class="background-header"
    :class="dataCard && dataCard.source === 'MICRODATA' && 'extra-padding-bottom'"
  >
    <div class="header-wrapper has-side-bars">
      <ItemHeader
        :data-card="dataCard"
        :data-favs="dataCard.favourites ? dataCard.favourites : []"
        :reload-data-card="reloadDataCard"
      />
      <div class="item-2cols">
        <div class="item-title">
          <ItemDescription
            :data-card="dataCard"
            :document-link="documentLink"
            :has-destination="hasDestination"
            :datastory-link="datastoryLink"
          />
        </div>
        <div class="item-additions">
          <ItemAdditions
            :data-card="dataCard"
            :data-values="dataValues"
            :definition-camps="campDefinitionTable"
            :files-for-last-year="filesForYears[yearsAvailable[0]]"
            :last-year="yearsAvailable[0]"
            @change-detail-table-info="changeDetailTableInfo"
          />
        </div>
      </div>
      <div class="modal-container">
        <modal
          name="modal-additional-info"
          :width="isMobile ? '90%' : '60%'"
          :height="isMobile ? '80%' : '70%'"
          :style="isMobile ? 'marginTop: 5%' : 'marginTop: 0%'"
        >
          <ModalTable
            :modal-close="() => hide('modal-additional-info')"
            :title="$t('additional_info')"
            :numeration="false"
            :data-table="additionalInfoTable"
          />
        </modal>
        <modal
          name="modal-complement-info"
          :width="isMobile ? '90%' : '60%'"
          :height="isMobile ? '80%' : '70%'"
          :style="isMobile ? 'marginTop: 5%' : 'marginTop: 0%'"
        >
          <ModalTable
            :modal-close="() => hide('modal-complement-info')"
            :title="$t('complement_info')"
            :table-note="dataValues && dataValues.datasetFieldsDescription"
          />
        </modal>
        <modal
          name="modal-camp-definition"
          :width="isMobile ? '90%' : '60%'"
          :height="isMobile ? '80%' : '70%'"
          :style="isMobile ? 'marginTop: 5%' : 'marginTop: 0%'"
        >
          <ModalTable
            :modal-close="() => hide('modal-camp-definition')"
            :title="$t('camps_definition_title')"
            :numeration="false"
            :data-table="campDefinitionTable"
          />
        </modal>
        <modal
          name="modal-file-details"
          :width="isMobile ? '90%' : '60%'"
          :height="isMobile ? '80%' : '70%'"
          :style="isMobile ? 'marginTop: 5%' : 'marginTop: 3%'"
        >
          <ModalTable
            :modal-close="() => hide('modal-file-details')"
            :title="$t('file_details_title')"
            :numeration="false"
            :data-table="dataTableFile"
            :data-file-info="dataFileInfo"
          />
        </modal>
        <modal
          name="modal-microdata-api"
          :width="isMobile ? '90%' : '60%'"
          :height="isMobile ? '80%' : '65%'"
          :style="isMobile ? 'marginTop: 5%' : 'marginTop: 0'"
        >
          <!--GRJ2EE-8911 (Añadido el nuevo modal) -->
          <ModalMicrodataApi
            :modal-close="() => hide('modal-microdata-api')"
            :data-file-info="dataFileInfo"
          />
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
import ItemHeader from './ItemHeader.vue'
import ItemDescription from './ItemDescription.vue'
import ItemAdditions from './ItemAdditions.vue'
import ModalTable from '../modals/ModalTable.vue'
import { t } from '../../i18n/index'
import dayjs from 'dayjs'
import ModalMicrodataApi from '../modals/ModalMicrodataApi.vue'
/**
 * Micro Data view disposition
 * @example [none]
 */
export default {
  name: 'ItemCommonDescription',
  components: { ItemHeader, ItemDescription, ItemAdditions, ModalTable, ModalMicrodataApi },
  props: {
    /**
     * Item object information getted from api
     */
    dataCard: {
      type: Object,
    },
    /**
     * Item object information getted from opendata-ajuntament
     */
    dataValues: {
      type: Object,
    },
    dataTableFile: {
      type: Array,
    },
    dataFileInfo: {
      type: Object,
    },
    documentLink: {
      type: String,
    },
    hasDestination: {},
    datastoryLink: {
      type: String,
    },
  },
  computed: {
    campDefinitionTable() {
      let definitionTable = []
      if (this.dataValues && this.dataValues.extres) {
        definitionTable = this.dataValues.extres.map(x => {
          return {
            camp_name: x.key,
            description: x.value,
          }
        })
      }
      return definitionTable
    },
    additionalInfoTable() {
      let infoTable = []
      if (
        this.dataValues &&
        this.dataCard &&
        this.dataCard.source &&
        this.dataCard.source === 'MICRODATA'
      ) {
        //TITLE
        infoTable.push({
          camp_name: t('add_title'),
          description: this.dataValues.titleTranslated,
        })
        //MORE INFO
        infoTable.push({
          camp_name: t('add_more_info'),
          description: this.dataValues.urlReturn,
        })
        //FONT
        infoTable.push({
          camp_name: t('add_font'),
          description: this.dataValues.docSource,
        })
        //GEOLOCATION
        infoTable.push({
          camp_name: t('add_geo'),
          description: this.dataValues.geolocation !== 'No' ? 'Si' : 'No',
        })
        //LONG AVAILABLE
        infoTable.push({
          camp_name: t('add_long_available'),
          description: this.dataValues.longFormat !== 'No' ? 'Si' : 'No',
        })
        //HISTORIC
        infoTable.push({
          camp_name: t('add_historic'),
          description: this.dataValues.isHistorical !== 'No' ? 'Si' : 'No',
        })
        //API CKAN
        infoTable.push({
          camp_name: t('add_api_ckan'),
          description: this.dataValues.isApi !== 'No' ? 'Si' : 'No',
        })
        //TOKEN REQUIRED
        infoTable.push({
          camp_name: t('add_token'),
          description: this.dataValues.isTokenRequired !== 'No' ? 'Si' : 'No',
        })
        //GERENCIA
        infoTable.push({
          camp_name: t('add_gerence'),
          description: this.dataValues.author,
        })
        //DEPARTAMENT
        infoTable.push({
          camp_name: t('add_department'),
          description: this.dataValues.department,
        })
        //PUBLICATION DATE
        infoTable.push({
          camp_name: t('add_publication_date'),
          //pintar amb el format que es vulgui
          description: dayjs(this.dataValues.publishDate.replace('Z', '')).format('DD/MM/YYYY'),
        })
        //PUBLICATION FREQ
        infoTable.push({
          camp_name: t('add_publication_freq'),
          description: (this.dataValues.frequency === "PETICIO_NEGOCI") ? t('freq_peticio_negoci') : this.dataValues.frequency,
        })
        //RECENT VIEWS
        infoTable.push({
          camp_name: t('add_recent_views'),
          description: '__',
        })
        //TOTAL VIEWS
        infoTable.push({
          camp_name: t('add_total_views'),
          description: '__',
        })
        infoTable.push({
          camp_name: t('add_dades_alt_valor'),
          description: this.dataValues.dadesAltValor ?? this.dataValues.dades_alt_valor ?? '__',
        })
      }
      return infoTable
    },
    yearsAvailable() {
      let yearsArray = []
      if (
        this.dataValues &&
        this.dataCard &&
        this.dataCard.source &&
        this.dataCard.source === 'MICRODATA'
      ) {
        let currentYear
        this.dataValues.resources.forEach(element => {
          currentYear = dayjs(element.created).format('YYYY')
          if (yearsArray.indexOf(currentYear) === -1) {
            yearsArray.push(currentYear)
          }
        })
      }
      return yearsArray.sort(function (a, b) {
        return b - a
      })
    },
    filesForYears() {
      let objectFiles = {}
      if (
        this.dataValues &&
        this.dataCard &&
        this.dataCard.source &&
        this.dataCard.source === 'MICRODATA'
      ) {
        this.dataValues.resources.forEach(element => {
          if (!objectFiles[dayjs(element.created).format('YYYY')])
            objectFiles[dayjs(element.created).format('YYYY')] = []
          objectFiles[dayjs(element.created).format('YYYY')].push(element)
        })
      }
      return objectFiles
    },
  },
  methods: {
    reloadDataCard() {
      this.$emit('reload-data-card')
    },
    /**
     * Change the information of table details and open the modal
     * @param {Object} file information of file clicked
     * @public This is a public method
     */
    changeDetailTableInfo(file) {
      this.$emit('change-detail-table', file)
    },
    /**
     * Hide the modal recived by param
     * @param {String} val id of modal to close
     * @public This is a public method
     */
    hide(val) {
      this.$modal.hide(val)
    },
  },
}
</script>

<style lang="stylus" scoped>
.extra-padding-bottom
  padding-bottom: vw(30px)

.background-header
  overflow: hidden
  position: relative

  &:before
    background: linear-gradient(135deg, #54AEEF 0, #7360EA 100%)
    content: ""
    filter: blur(200px)
    height: 100%
    left: 0
    opacity: 0.1
    pointer-events: none
    position: absolute
    top: 0
    width: 100%

.header-wrapper
  padding-bottom: vw(40px)
  padding-top: vw(35px)

  .mobile &
    margin-bottom: vw(20px)

.item-2cols
  display: flex
  gap: vw(40px)
  position: relative

  .mobile &
    flex-direction: column
    gap: vw(10px)

.item-title
  display: flex
  flex: 1 1 0%
  padding-bottom: vw(30px)

  .mobile &
    padding-bottom: vw(20px)

.item-additions
  background-color: #fff
  // height: fit-content
  border-radius: 8px
  height: 100%
  position: relative
  // margin-bottom: vw(15px)
  width: vw(335px)
  z-index: 1

  .mobile &
    width: 100%

    &:not(:last-child)
      margin-bottom: vw(30px)
</style>
